import apiClient from './apiClient';

/**
 * Per-contract geofence polygon and the new alarms table.
 */
const geofenceService = {
    async getGeofence(contractId) {
        return await apiClient.get(`/contracts/${contractId}/geofence`);
    },
    async saveGeofence(contractId, polygon, enabled = true) {
        return await apiClient.put(`/contracts/${contractId}/geofence`, { polygon, enabled });
    },

    async listAlarms(filters = {}) {
        const qs = new URLSearchParams(filters).toString();
        return await apiClient.get(`/alarms${qs ? '?' + qs : ''}`);
    },
    async closeAlarm(id) {
        return await apiClient.patch(`/alarms/${id}/close`, {});
    },
    async alarmStats() {
        return await apiClient.get('/alarms/stats');
    }
};

export default geofenceService;
